module.exports = __webpack_public_path__ + "img/popular1.00db9679.png";